import { useRouter } from 'next/router'

export default function Container ({ children }) {
  const router = useRouter()
  const { search } = router.query

  return children({ search })
}
